export default "__VITE_ASSET__CxrCV0XK__"